// extracted by mini-css-extract-plugin
export default {"hidden":"Image_hidden__iSUS6"};